import { useEffect } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

const AnimatedNumber = ({ value = 0, className }) => {
  const spring = useSpring(0, { stiffness: 80, damping: 20 });
  const display = useTransform(spring, (latest) => Math.round(latest));

  useEffect(() => {
    spring.set(value);
  }, [value, spring]);

  return <motion.span className={className}>{display}</motion.span>;
};

export default AnimatedNumber;
